import Vue from 'vue';
import '../theme/index.css'
import ElementUI from 'element-ui';
import router from './router'
import Layout from './pages/Layout.vue';
// #FFC500
Vue.use(ElementUI, { size: 'small'});

new Vue({
  el: '#app',
  router,
  render: h => h(Layout)
});
